import React from "react";
import { TextField, InputAdornment } from "@mui/material";

const CustomTextField = ({
    label,
    name,
    value,
    onChange,
    icon: Icon,
    multiline = false,
    rows = 1,
    type = "text",
    select = false,
    children,
    ...props
}) => {
    return (
        <TextField
        fullWidth
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        type={type}
        select={select}
        multiline={multiline}
        rows={rows}
        sx={{ mb: 2 }}
        InputProps={{
            startAdornment: Icon ? (
            <InputAdornment position="start">
                <Icon />
            </InputAdornment>
            ) : null,
        }}
        {...props}
        >
        {children}
        </TextField>
    );
};

export default CustomTextField;
